import Common from '../common'
var Js = Common('message')
export default {
	name: 'message',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: '消息ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'user',
					label: '留言用户',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					formatter:function(val){
						return val.user.nickname
					},
					width:150
				},
				// {
				// 	key: 'title',
				// 	label: '姓名',
				// 	application: ['编辑', '添加'],
				// 	componentName: 'sls-input',
				// 	listType: 'normal',
				// 	header_search: {
				// 		componentName: 'sls-input',
				// 		style: 'width:160px;margin-right:2px;',
				// 		placeholder: '请输入姓名',
				// 		clearable: true,
				// 		defaultValue: '',
				// 		optionsName: '',
				// 		changeFunc: function(val, self) {
				// 			if (val) {
				// 				self.searchItem.title = val;
				// 			} else {
				// 				delete self.searchItem.title;
				// 			};
							
				// 		},
				// 	},
				// },
				// {
				// 	key: 'phone',
				// 	label: '电话',
				// 	application: ['编辑', '添加'],
				// 	componentName: 'sls-input',
				// 	listType: 'normal',
				// 	header_search: {
				// 		componentName: 'sls-input',
				// 		style: 'width:160px;margin-right:2px;',
				// 		placeholder: '请输入电话',
				// 		clearable: true,
				// 		defaultValue: '',
				// 		optionsName: '',
				// 		changeFunc: function(val, self) {
				// 			if (val) {
				// 				self.searchItem.phone = val;
				// 			} else {
				// 				delete self.searchItem.phone;
				// 			};
							
				// 		},
				// 	},
				// },
				{
					key: 'content',
					label: '留言内容',
					application: ['编辑', '添加'],
					componentName: 'sls-textarea',
					listType: 'normal',

				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: "type",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'typeOptions',
					listType: '',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.type == 1) {
							return '已处理';
						} else {
							return '未处理';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};
							
						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_messageUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						}
					},
				},

				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {

						apiName: function(self) {
							return "api_messageUpdate"
						},

						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}

					},
				},

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_messageAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								phone: '',
								content: '',
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 1;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},

			],

			searchItem: {},
			startSearchItem: {},
			optionData: {
				labelOptions: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				typeOptions: [{
					text: '未处理',
					value: 0
				}, {
					text: '已处理',
					value: 1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				fixSearchItem: {
					status: 1
				},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
		},




		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				user:{
					tableName:'User',
					middleKey:'user_no',
					key:'user_no',
					condition:'=',
					info:['nickname','headImgUrl']
				}
			}
			var res = await self.$$api_messageGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/content/message.js